export const SELECT_NOTIFICATION_ALERT = 'SELECT_NOTIFICATION_ALERT';
export const ACCOUNT_QUARTERLY_REPORT = 'ACCOUNT_QUARTERLY_REPORT';
export const ACCOUNT_NOW_CURRENT = 'Account now current';
